import apiRequest from './apiRequest';

export default async function postBookmarkProject(projectID: string) {
  return await apiRequest(
    'mogen-orchestration',
    `/v2/projects/${projectID}/bookmark`,
    {
      method: 'POST',
    },
  );
}
